import Keycloak from 'keycloak-js'
import getLanguage from '@/helper/language'

const keycloak = new Keycloak({
    url: `${import.meta.env.VITE_KEYCLOAK_BASEURL}/auth`, // default AMS auth url
    realm: 'credref',
    clientId: 'CR-CP'
})

const APP_BASE = '/benutzerverwaltung/'
const LOGOUT_REDIRECT_URI = `${location.protocol}//${location.host}${APP_BASE}`
const OTP_REDIRECT_URI = `${location.protocol}//${location.host}${APP_BASE}sicherheit`
const forceUpdateKeycloakToken = async() => {
    await keycloak
        .updateToken(-1)
        .then(refreshed => {
            if (refreshed) {
                console.log('[Keycloak] Forced token refresh')
                console.log(
                    '[Keycloak] Updated keycloak token: ',
                    JSON.stringify(window.keycloak.token)
                )

                localStorage.setItem('vue-token', window.keycloak.token)
                localStorage.setItem(
                    'vue-refresh-token',
                    window.keycloak.refreshToken
                )
            } else {
                console.log('[Keycloak] token not refreshed')
            }
        })
        .catch(err => {
            console.log('[Keycloak] Failed to force refresh token:')
            console.error(err)
        })
}

const onAuthenticated = keycloakInstance => {
    localStorage.setItem('vue-token', keycloakInstance.token)
    localStorage.setItem('vue-refresh-token', keycloakInstance.refreshToken)
    console.log('[onAuth] ', keycloakInstance)
    window.keycloak = keycloakInstance
}

const login = async(
    initOptions = { onLoad: 'login-required', pkceMethod: 'S256', locale: getLanguage() },
    next = false,
    nextName = false
) => {
    try {
        const auth = await keycloak.init(initOptions)

        if (!auth) {
            console.log('[Keycloak] NOT Authenticated')
            if (
                nextName &&
                nextName.onLoggedOut &&
                nextName.onLoggedOut.length
            ) {
                console.log(
                    'init.success: not authenticated, redirect to ',
                    nextName.onLoggedOut
                )
                next({ name: nextName.onLoggedOut })
            }
        } else {
            console.log('[Keycloak] Authenticated ', keycloak.token)
            console.dir(keycloak)
            onAuthenticated(keycloak)
            if (nextName && nextName.onLoggedIn && nextName.onLoggedIn.length) {
                console.log(
                    'init.success: not authenticated, redirect to ',
                    nextName.onLoggedIn
                )
                next({ name: nextName.onLoggedIn })
            }
        }
    } catch (err) {
        console.log('[Keycloak] Authentication failed')
        if (nextName && nextName.onLoggedOut && nextName.onLoggedOut.length) {
            console.log(
                'init.success: not authenticated, redirect to ',
                nextName.onLoggedOut
            )
            next({ name: nextName.onLoggedOut })
        }
    }
}
const logout = async(
    initOptions = { redirectUri: LOGOUT_REDIRECT_URI, pkceMethod: 'S256', locale: getLanguage() }
) => {
    const keycloakExists = setInterval(() => {
        if (
            window.keycloak &&
            window.keycloak.logout &&
            typeof window.keycloak.logout === 'function'
        ) {
            clearInterval(keycloakExists)

            window.keycloak.logout(initOptions)
        }
    }, 200)
    localStorage.removeItem('vue-token')
    localStorage.removeItem('vue-refresh-token')
}

const configureOTP = async(requiredAction = 'CONFIGURE_TOTP', currentLocale = getLanguage()) => {
    const options = {
        redirectUri: OTP_REDIRECT_URI,
        action: requiredAction,
        locale: currentLocale
    }
    await keycloak.login(options)
}

const removeOTP = async(credentialId, currentLocale = getLanguage()) => {
    const options = {
        redirectUri: OTP_REDIRECT_URI,
        action: `delete_credential:${credentialId}`,
        locale: currentLocale
    }
    await keycloak.login(options)
}

export { forceUpdateKeycloakToken, login, logout, configureOTP, removeOTP, LOGOUT_REDIRECT_URI }
